import React from 'react';
import { IAuditoriaAdiantamentoSalarioResultado } from '../interfaces/IAuditoriaAdiantamentoSalario';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaAdiantamentoSalarioResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Adiantamento de Salários não é um tributo — é uma auditoria complementar que
// verifica se lançamentos de adiantamento salarial/a pessoal foram conciliados (status real do
// motor de conciliação deste projeto) dentro de 30 dias. Segue o mesmo padrão de seção própria já
// usado para os outros módulos de auditoria.
const AuditoriaResumoAdiantamentoSalario: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.adiantamentosPendentes?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Adiantamento de Salários</h3>
      <p className='text-muted'>
        Auditoria complementar — adiantamentos salariais/a pessoal pendentes de conciliação por mais de 30 dias
        indicam despesa de remuneração não reconhecida no período (Art. 290 RIR/2018). Multa ECD potencial
        (Art. 12, II, Lei 8.218/1991) — 5% sobre o valor pendente, limitada a 1% da receita bruta do
        período. Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ADIANTAMENTO_SALARIO')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Adiantamento de Salários</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} adiantamento{totalOcorrencias === 1 ? '' : 's'} salarial{totalOcorrencias === 1 ? '' : 'is'} pendente{totalOcorrencias === 1 ? '' : 's'} identificado{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% sobre o valor pendente, limitada a 1% da receita bruta (Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoAdiantamentoSalario;
